import TopupBalance from '@beep/topup-standalone';
import classNames from 'classnames/bind';
import { MINIMAL_PAYMENT_SUM, NOT_DIGIT } from 'constants/common';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  Button,
  DataBlocks,
  ErrorBlock,
  I18n,
  Link,
  TextInput,
} from 'components';

import { pathOr } from 'ramda';
import { getPaySumString } from 'utils/formatString';
import { fetchData } from '../../actions';
import PromisedPayment from '../../components/PromisedPayment';
import SpfButton from '../../components/SfpPayment/SpfButton';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

class Payments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      paySum: 100,
      isTopUpWidgetOpen: false,
      paymentMethod: undefined,
    };
  }

  componentDidMount() {
    const { data } = this.props;

    if (data) {
      const recommendedPaySum = Math.ceil(data.amountToPay);
      if (recommendedPaySum > 100) {
        setTimeout(() => {
          this.setState({ paySum: recommendedPaySum });
        });
      }
    }
  }

  updateBalance = () => {
    this.props.actions.fetchData(['Balance', 'Status']);
  };

  updatePaySum = (value) => {
    this.setState({
      paySum: Number(value.replace(NOT_DIGIT, '')),
    });
  };

  onBlurPaySum = () => {
    this.setState((state) => ({
      paySum:
        state.paySum < MINIMAL_PAYMENT_SUM ? MINIMAL_PAYMENT_SUM : state.paySum,
    }));
  };

  setIsTopUpWidgetOpen = (isOpen, isSBP) => {
    this.setState({
      isTopUpWidgetOpen: isOpen,
      paymentMethod: isSBP ? 'sbp' : undefined,
    });
  };

  onPaymentClick = () => {
    this.setIsTopUpWidgetOpen(true);
  };

  render() {
    const { data, error } = this.props;
    const { paySum, isTopUpWidgetOpen, paymentMethod } = this.state;

    if (error && error.type) {
      return (
        <ErrorBlock
          className="halfWidth"
          title={<I18n path="home.payments.blockTitle" />}
          refreshAction={this.updateBalance}
        />
      );
    }

    const blockLinks = [];
    if (data.promisedPaymentLink) {
      blockLinks.push({
        children: data.promisedPaymentLink.title,
        href: data.promisedPaymentLink.url,
      });
    }
    if (data.personalCreditLimitLink) {
      blockLinks.push({
        children: data.personalCreditLimitLink.title,
        href: data.personalCreditLimitLink.url,
      });
    }
    blockLinks.push({
      children: 'Все способы оплаты',
      href: data.paymentBaseUrl || data.paymentUrl,
    });
    const isPaySumInValid = +paySum < 100 || +paySum > 15000;

    return (
      <DataBlocks.Block
        className="halfWidth"
        title={<I18n path="home.payments.blockTitle" />}
        links={blockLinks}
        info={(
          <img
            src="//static.beeline.ru/upload/images/mlk/images/paymentSystems.svg"
            alt=""
          />
        )}
      >
        <TopupBalance
          isOpen={isTopUpWidgetOpen}
          sum={paySum}
          accountNumber={data.ctn}
          prefilledAccountNumber={data.ctn}
          setIsOpen={(isOpen) => {
            this.setIsTopUpWidgetOpen(isOpen);
          }}
          paymentMethod={paymentMethod}
        />
        <div className={cx('payForm')}>
          <div>
            <TextInput
              className={cx('payInput')}
              value={paySum}
              onChange={this.updatePaySum}
              onBlur={this.onBlurPaySum}
            />
            <span className={cx('payCurrency')}>₽</span>
            <div className={cx('paySumTooltip')}>
              {getPaySumString(data.minPaymentAmount, data.maxPaymentAmount)}
            </div>
          </div>
          <div className={cx('payButton')}>
            <div className={cx('payButton')}>
              <Button wide onClick={this.onPaymentClick}>
                <I18n path="home.balance.payButton" />
              </Button>
            </div>
          </div>
        </div>

        {data.autoPaymentParams && data.autoPaymentParams.autoMtopupPayment && (
          <div className={cx('paymentService')}>
            <i className={cx('statusIndicator')} />
            <Link href={data.autoPaymentParams.autoMtopupPayment.url}>
              <I18n
                className={cx('paymentServiceTitle')}
                path="home.balance.autoMtopupPayment"
              />
            </Link>
          </div>
        )}

        {data.autoPaymentParams && data.autoPaymentParams.autoBankPayment && (
          <div className={cx('paymentService')}>
            <i className={cx('statusIndicator')} />
            <Link href={data.autoPaymentParams.autoBankPayment.url}>
              <I18n
                className={cx('paymentServiceTitle')}
                path="home.balance.autoBankPayment"
              />
            </Link>
          </div>
        )}

        {data.promisedPayment && data.promisedPaymentLink && (
          <PromisedPayment
            promisedPayment={data.promisedPayment}
            promisedPaymentLink={data.promisedPaymentLink}
            currency={data.currency}
          />
        )}
        <SpfButton
          onClick={() => {
            this.setIsTopUpWidgetOpen(true, true);
          }}
          disabled={isPaySumInValid}
        />
      </DataBlocks.Block>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: {
      ...state.home.balance.data,
      ctn: state.application.settings.ctn,
      amountToPay: pathOr(
        null,
        ['home', 'profileSummary', 'data', 'amountToPay'],
        state,
      ),
    },
    error: state.home.balance.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ fetchData }, dispatch),
  };
}

Payments.propTypes = {
  data: PropTypes.object,
  error: PropTypes.object,
  actions: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(Payments);
